import 'zone.js';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { SaleItemSelectorModule } from './sale-item-selector/sale-item-selector.module';

if (environment.production && !environment.prodEnabled) {
  enableProdMode();
  environment.prodEnabled = true;
}

platformBrowserDynamic().bootstrapModule(SaleItemSelectorModule)
  .catch((err) => console.error(err));
